import React, { useEffect, useRef } from 'react';
import axios from 'axios';

class HttpClientImpl {
  constructor(baseURL) {
    this.axiosInstance = axios.create({
      baseURL,
      timeout: 60000,
      withCredentials: true
    });

    this.axiosInstance.interceptors.request.use((config) => {
      if (/\/undefined|\/null/.test(config.url)) {
        return Promise.reject(new Error(`Invalid URL contains "/undefined" or "/null": ${config.url}`));
      }

      return config;
    });
  }

  get(url, config) {
    return this.axiosInstance.get(url, config);
  }

  post(url, data, config) {
    return this.axiosInstance.post(url, data, config);
  }

  put(url, data, config) {
    return this.axiosInstance.put(url, data, config);
  }

  patch(url, data, config) {
    return this.axiosInstance.patch(url, data, config);
  }

  delete(url, config) {
    return this.axiosInstance.delete(url, config);
  }
}

class AppShellImpl {
  constructor(baseURL, getLocaleFn, subscribe) {
    this.httpClient = new HttpClientImpl(baseURL);
    this.getLocaleFn = getLocaleFn;
    this.subscribe = subscribe;
  }

  extractSFFO = (canonicalUri) => canonicalUri;
  // Resolved dynamically so MFEs that read it once still get the current value.
  getLocale = async () => this.getLocaleFn();
  // MFEs (e.g. webhookui's i18n) subscribe here to react to language changes without remounting.
  watchLocale = (callback) => this.subscribe(callback);
  getSelf = async () => undefined;
  getHttpClient = () => Promise.resolve(this.httpClient);
  getLinks = async (permission) => [permission];
  isPermitted = async (permission) => permission;
}

export const AppShellProvider = ({ children, baseURL, locale = 'en-US' }) => {
  const localeRef = useRef(locale);
  const listenersRef = useRef(new Set());

  useEffect(() => {
    localeRef.current = locale;
    listenersRef.current.forEach((listener) => listener(locale));
  }, [locale]);

  useEffect(() => {
    const appShell = new AppShellImpl(
      baseURL,
      () => localeRef.current,
      (callback) => {
        listenersRef.current.add(callback);
        return () => listenersRef.current.delete(callback);
      }
    );
    window.getAppShell = () => appShell;
    console.log('AppShell initialized with baseURL:', baseURL);

    return () => {
      delete window.getAppShell;
    };
  }, [baseURL]);

  return children;
};

